import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface OssVatRateSetDefaultParams {
    readonly countryId: number;
    readonly id: number;
    readonly mode: 'set' | 'unset';
}

export type OssVatRateSetDefaultResponse = {
    value: number,
    version: string
}[];

export class OssVatRateSetDefaultCommand extends Command<OssVatRateSetDefaultParams, OssVatRateSetDefaultResponse> { }

export class OssVatRateSetDefaultCommandHandlerBase implements CommandHandler<OssVatRateSetDefaultCommand, OssVatRateSetDefaultParams, OssVatRateSetDefaultResponse> {
    private static Url = TaggedUrl.join('/sales/vatRates/country/:countryId/default/:id', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: OssVatRateSetDefaultCommand): Promise<OssVatRateSetDefaultResponse> {
        const request = command.params?.mode === 'set'
            ? this.http.put(fillPlaceholders(OssVatRateSetDefaultCommandHandlerBase.Url, { countryId: command.params?.countryId, id: command.params?.id }))
            : this.http.delete(fillPlaceholders(OssVatRateSetDefaultCommandHandlerBase.Url, { countryId: command.params?.countryId, id: command.params?.id }));

        return(await request).data;
    }
}
